module.exports = [{"type":"title","text":"2025-08-21"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"U本位永續合約：API和Websocket不支持外匯"},{"type":"html","text":"U本位永續合約：查詢當前全部掛單接口響應增加positionId字段"},{"type":"html","text":"U本位永續合約：修復了TP單撤單接口和查詢訂單接口中，clientOrderId 為空的問題"},{"type":"html","text":"U本位永續合約：修復了設置持倉模式接口錯誤響應問題"},{"type":"html","text":"U本位永續合約：下單接口workingType字段移除了INDEX_PRICE類型"},{"type":"html","text":"賬戶與錢包：提幣接口優化，當資金賬戶余額不足時，系統將自動從現貨賬戶補充資金"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2025-08-21.json
// module id = ZXEx
// module chunks = 3